import { render, staticRenderFns } from "./AvatarInterface.vue?vue&type=template&id=2d916d39&"
import script from "./AvatarInterface.vue?vue&type=script&lang=js&"
export * from "./AvatarInterface.vue?vue&type=script&lang=js&"
import style0 from "./AvatarInterface.vue?vue&type=style&index=0&id=2d916d39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports